module.exports = __webpack_public_path__ + "static/media/scalability.19136ebb.svg";